export default __webpack_public_path__ + "static/media/right.061ef8b5.svg";